import { Path, Rect, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M5 5H19M5 19H19" vectorEffect="non-scaling-stroke" />
		<Rect x="5" y="9" width="14" height="6" fill="currentColor" stroke="none" />
	</SVG>
);
